import script from "./ButtonFixed.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonFixed.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonFixed.vue?vue&type=style&index=0&id=3b15496a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b15496a"]])

export default __exports__